import { ICommonSettings, ISessionSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigSessionSettings, SESSION_SETTINGS_SEARCH_TERMS } from "./app-settings-config-session";

export interface IConfigSessionInputState {
  showModal: boolean;
  editingSessionId: string;
}

export interface IConfigSessionInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigSessionInput extends PureComponent<IConfigSessionInputProps, IConfigSessionInputState> {
  formInputName = ["webConfig", "sessionSettingsId"];

  constructor(props: IConfigSessionInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingSessionId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingSessionId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingSessionId: id, showModal: true });
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as ISessionSetting,
      ...(commonSettings.sessionSettings || [])
    ];
    return (
      <>
        <ConfigSessionSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingSessionId={this.state.editingSessionId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          searchTerms={SESSION_SETTINGS_SEARCH_TERMS}
          formInputName={this.formInputName}
          options={options.map((item) => ({
            id: item.id,
            name: item.name,
            // A global setting shown inside a project configuration is read-only here.
            editable: !item.isGlobalCommonConfigOnProjectConfig
          }))}
          allowClear
          tooltipContentKey="web_sessions_configuration"
          parentConfigValue={parentConfigValue}
          onRestore={() => handleUpdateCustomFormInput?.(this.formInputName, parentConfigValue ?? null)}
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          dropdownTestId="sessionsConfigurationDropdown"
          addNewTestId="sessionsConfigurationAddNewButton"
          editTestId="sessionSettingEditButton"
        />
      </>
    );
  }
}
